import { useCallback, useEffect, useState, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Unity, useUnityContext } from "react-unity-webgl";
import { useTranslation } from "react-i18next";
import { axiosPrivate } from "../../api/axios";

import { io } from "socket.io-client";
import DisasterChecklistDialog from "./DisasterChecklistDialog";

import useRefreshToken from "../../hooks/useRefreshToken";
import { useAuth } from "../../hooks/useAuth";

import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import { Icon } from "../icons";
import CloseIcon from "@mui/icons-material/Close";
import CarouselTotal from "../Sfv_Carousel";
import SideBar from "../SideBar";
import CustomProgressBar from "../ProgressBar";
import ProgressInfo from "../ProgressBar/progressInfo";
import RadarChart from "../Graph/radar";
import KPICards from "../KPICards";
import InfoTable from "../InfoTable";
import RiskTableDialog from "./RiskDialog";
import BrokenLogDialog from "./BrokenLogDialog";
import CCTVDialog from "./CCTVDialog";
import BrokenImageDialog from "./BrokenImageDialog";

import API_URL from "../../utils/API_URL";

import { useDispatch, useSelector } from "react-redux";
import { setChattingStatus } from "../../slice/authSlice";
// import MergeSummary from "../Summary/Merge";
// import SummaryResult from "../Summary/Result";
// import SummaryLine from "../Summary/SummaryLine";
// import PlanWeek from "../Summary/Week";
// import GanttSimulation1 from "../GanttSimulation/Sim1";
// import GanttSimulation2 from "../GanttSimulation/Sim2";
// import WorkerTable from "../WorkerTable";

// 로딩 화면 스타일 시트
import "../../styles/loader.css";
import ApsInformation from "./ApsInformation/ApsInformation";
import WorkOrderModal from "./ApsInformation/WorkOrderModal";
import RiskListModal from "./RiskInformation/RiskListModal";
import { useGetTableData } from "../APS/Plan/tableHooks";
import APS_URL from "../../utils/APS_URL";
import RiskAssessment from "./RiskInformation";
import { RiskLevelDetails } from "./RiskInformation/RiskLevelDetails";
import { RiskIndicators } from "./RiskInformation/RiskIndicators";

// 위험성 평가 커스텀 훅
import { useGetTableDataInQueryString } from "../RISK_ASSESSMENT/components/Table/hooks";
import { toast } from "react-toastify";
import DateModal from "../Sfv_DateModal";
import { setDisasterStatus } from "../../slice/authSlice";

// 재고관리 컴포넌트
import StockSideBar from "./StockSideBar";
import MonthStockGraph from "../Sfv_stock_graph/MonthStock";
import DayStockGraph from "../Sfv_stock_graph/DayStock";
import ProductivityChart from "./ProductivityChart";
import { set } from "react-hook-form";

import dayjs from "dayjs";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const DrawerTitle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const DrawerContent = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledTable = styled("table")(({ theme }) => ({
  width: "100%",
  borderCollapse: "collapse",
  "tbody tr td": {
    padding: "0.2rem 0.4rem",
  },
  "tbody tr td:first-of-type": {
    color: "#ffffff",
    width: "50%",
  },
  "tbody tr td:last-of-type": {
    color: "#878a99",
  },
}));

function SfvLePage() {
  const { t, i18n } = useTranslation();
  const auth = useAuth();

  const { group_code, project_code } = useParams();

  const { unityProvider, unload, sendMessage } = useUnityContext({
    loaderUrl: "https://preview.insightwin.com/Build/WebGL.loader.js",
    dataUrl: "https://preview.insightwin.com/Build/WebGL.data.gz",
    frameworkUrl: "https://preview.insightwin.com/Build/WebGL.framework.js.gz",
    codeUrl: "https://preview.insightwin.com/Build/WebGL.wasm.gz",
    streamingAssetsUrl: `https://preview.insightwin.com/StreamingAssets/${group_code}/${project_code}/le`,
  });

  useEffect(() => {
    // FIX: 메모리 누수 방지를 위해 컴포넌트 언마운트 시 Unity 인스턴스 정리
    return () => {
      // unload는 Promise를 반환하므로, 비동기 처리를 통해 안정적으로 종료 시도
      const cleanupUnity = async () => {
        try {
          await unload();
          console.log("Unity WebGL context unloaded.");
        } catch (error) {
          console.warn("Unity WebGL unload failed or context already lost:", error);
        }
      };
      cleanupUnity();
    };
  }, [unload]);

  useEffect(() => {
    document.title = t("pages.dt.digitalTwinTitle");
  }, [t]);
  const dispatch = useDispatch();
  const unityContainerRef = useRef(null);
  const [devicePixelRatio, setDevicePixelRatio] = useState(
    window.devicePixelRatio
  );
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerContent, setDrawerContent] = useState(null);
  const [currentMchId, setCurrentMchId] = useState("");
  const [apsData, setApsData] = useState([]);
  const [riskData, setRiskData] = useState([]);
  const [BrokenImageShow, setBrokenImageShow] = useState(false);
  const [CCTVShow, setCCTVShow] = useState(false);
  const [riskListOpen, setRiskListOpen] = useState(false);
  const [brokenLogShow, setbrokenLogShow] = useState(false);
  const [brokenLogData, setbrokenLogData] = useState({});
  const { chattingStatus, dateSystemStatus } = useSelector(
    (state) => state.auth
  );
  const [isLoading, setIsLoading] = useState(true);
  const [workOrderOpen, setWorkOrderOpen] = useState(false);
  const [totalQty, setTotalQty] = useState(0);
  const [workTime, setWorkTime] = useState([]);
  const [currentCompleteQty, setCurrentCompleteQty] = useState(0);
  const [workTimeString, setWorkTimeString] = useState({
    earliest: "",
    latest: "",
  });
  const [disasterScenario, setDisasterScenario] = useState(null);
  const [monthStockGraphOpen, setMonthStockGraphOpen] = useState(false);
  const [dayStockGraphOpen, setDayStockGraphOpen] = useState(false);
  const [stockOpen, setStockOpen] = useState(false);
  const socketRef = useRef(null);
  // useSelector 사용 시 구조 분해 할당 제거
  const userInfo = useSelector((state) => state.auth.user);
  const { productivityStatus } = useSelector((state) => state.auth);

  const RenderMode = Object.freeze({
    DT: "dtMode", // 디지털 트윈 모드
    SAFETY: "safetyMode", // 안전 모드
    // TODO: 추가 모드 필요 시 여기에 정의
  });
  const [modeStatus, setModeStatus] = useState(RenderMode.DT);

  const handleLogout = async () => {
    await unload();
    await auth.logout();
  };

  const handleDtInfoModeChange = useCallback((mode) => {
    // Unity로 모드 전송 (단일 선택)
    try {
      sendMessage("Canvas", "SetPropertyValue", `InsighTwinMode:${mode}`);
    } catch (e) {
      console.error("Unity SendMessage failed:", e);
    }
  }, [sendMessage]);

  const fetchData = async (mchId) => {
    try {
      const response = await axiosPrivate.post("/drawer/getAssetData", {
        mchId,
        group_code,
        project_code,
      });

      if (response.status === 404) {
        setDrawerContent(null);
        return;
      }

      const { asset } = response.data;

      setDrawerContent(asset);
      console.log(asset);
    } catch (error) {
      console.error("Error fetching data:", error);
      setDrawerContent(null);
    }
  };

  // 시스템 활성화 상태 관리
  const [systemStatus, setSystemStatus] = useState({ APS: false, SAFE: false });

  // 시스템 활성화 상태 조회
  useEffect(() => {
    const fetchSystemStatus = async () => {
      try {
        const response = await axiosPrivate.post("/project/getSystemStatus", {
          group_code,
          project_code,
        });
        setSystemStatus(response.data);
      } catch (error) {
        console.error("시스템 상태 조회 실패:", error);
      }
    };
    fetchSystemStatus();
  }, [group_code, project_code]);

  // apsData 훅 - enabled 옵션으로 조건부 실행
  const { apsData: fetchedApsData } = useGetTableData(
    "apsData", // 고정된 키 사용
    `/getApsInformation?group_code=${group_code}&project_code=${project_code}&mch_id=${currentMchId}`,
    "apsData",
    Boolean(systemStatus.APS) && Boolean(currentMchId) // APS 활성화 및 mchId 존재 여부 확인 강화
  );

  // apsData가 변경될 때마다 상태 업데이트
  useEffect(() => {
    if (fetchedApsData && fetchedApsData.length > 0) {
      setApsData(fetchedApsData);
    } else {
      setApsData([]);
    }
  }, [fetchedApsData]);

  // 기준 날짜 상태 관리
  const [referenceDate, setReferenceDate] = useState(null);
  const handleSetReferenceDate = (date) => {
    const t = dayjs(date);                         // 그냥 파싱
    const yyyymmdd = t.isSame(dayjs(), 'day')      // 오늘이면
      ? 'Now'
      : t.format('YYYYMMDD');                      // 아니면 YYYYMMDD
    sendMessage('Canvas', 'SetDateProperty', `DS ${yyyymmdd}`);
    setReferenceDate(date);
  };
  useEffect(() => {
    setReferenceDate(dayjs().format("YYYY-MM-DD HH:mm:ss"));
  }, []);

  // 위험성 평가 정보(상.중.하) 데이터 조회 요청 (추후 삭제 예정)
  const getRiskLowMiddleHigh = useGetTableDataInQueryString(
    "request",
    "/getRiskLowMiddleHigh",
    group_code,
    project_code,
    { params: { dateParam: referenceDate, dt_sync_id: currentMchId } }, // 장비 id로 데이터 조회
    Boolean(currentMchId) && systemStatus.SAFE // dt_sync_id 존재 및 SAFE 활성화 확인
  );
  // getRiskLowMiddleHigh가 변경될 때마다 상태 업데이트
  useEffect(() => {
    if (!getRiskLowMiddleHigh.data || getRiskLowMiddleHigh.data.length === 0) {
      return;
    }
    const tempData = { ...getRiskLowMiddleHigh.data };
    setRiskData(tempData);
  }, [getRiskLowMiddleHigh.data]);

  const fetchBrokenLogData = async (mchId) => {
    try {
      const response = await axiosPrivate.post("/drawer/getBrokenLogData", {
        mchId,
      });
      if (response.status === 404) {
        setbrokenLogData({});
        return;
      }
      const { brokenLogData } = response.data;

      setbrokenLogData(brokenLogData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setbrokenLogData({});
    }
  };

  const SFV_FinishLoading = useCallback((msg) => {
    console.log(msg);
    if (msg === "Initialization start") {
      setIsLoading(false);
    } else if (msg === "Initialization Done") {
      const lang2 = i18n.language?.substring(0, 2);
      const unityLang = lang2 === "jp" ? "JPN" : lang2 === "ko" ? "KOR" : "ENG";
      sendMessage("Canvas", "SetPropertyValue", "Language:" + unityLang);
    }
  }, [sendMessage, i18n.language]);

  const SFV_UpdateData = useCallback(
    (mchId, pickingData) => {
      console.log("MchID:", mchId, "PickingData:", pickingData);
      if (mchId !== "" && pickingData.includes('"type":21')) {
        setCurrentMchId(mchId);
        fetchData(mchId);
        setDrawerOpen(true);
      }
      if (mchId === "1" && pickingData.includes('"type":0')) {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then(() => {
            console.log("마이크 권한 승인");
            sendMessage("Canvas", "CurrentMicrophoneStatus", "Enable");
          })
          .catch((error) => {
            console.error("마이크 권한 획득 실패: ", error);
            sendMessage("Canvas", "CurrentMicrophoneStatus", error.message);
          });
      }
      if (mchId !== "" && pickingData.includes('"type":20')) {
        console.log("창고 피킹");
        setCurrentMchId(mchId);
        setStockOpen(true);
      }
    },
    [sendMessage]
  );

  const SFV_UpdateStatus = useCallback((type, status) => {
    dispatch(
      setChattingStatus({
        type,
        status,
      })
    );
    if (type === "Mode") {
      const str = status.split(",")[1];
      // type 이 Mode일 경우, status No=0, No=1, No=2, No=3
      switch (str) {
        // case "No=3,Safe":
        case "Safe":
          setModeStatus(RenderMode.SAFETY);
          break;
        default:
          setModeStatus(RenderMode.DT);
      }
    };
    // setStatus(`${type}: ${status}`);
  }, [dispatch]);

  const updateCanvasSize = () => {
    const unityContainer = unityContainerRef.current;
    if (unityContainer) {
      const canvas = unityContainer.querySelector("canvas");
      if (canvas) {
        const newWidth = unityContainer.clientWidth;
        const newHeight = unityContainer.clientHeight;
        const resolutionWidth = newWidth * window.devicePixelRatio;
        const resolutionHeight = newHeight * window.devicePixelRatio;

        // 유니티 WebGL 내부 해상도 업데이트
        canvas.width = resolutionWidth;
        canvas.height = resolutionHeight;
      }
    }
  };

  // Refresh Token 갱신
  const refresh = useRefreshToken();
  useEffect(() => {
    console.log("aps information useeffect call");
    const total = apsData
      .map((i) => i.product_qty)
      .reduce((acc, cur) => acc + cur, 0);
    setTotalQty(total);
    const opertimeSplit = apsData[0]?.operation_time.split(",") ?? [];
    const res = [];
    for (let i = 0; i < opertimeSplit.length; i += 2) {
      if (i + 1 < opertimeSplit.length) {
        const startMinutes = parseInt(opertimeSplit[i]);
        const endMinutes = parseInt(opertimeSplit[i + 1]);
        const startHours = Math.floor(startMinutes / 60);
        const startMins = startMinutes % 60;
        const endHours = Math.floor(endMinutes / 60);
        const endMins = endMinutes % 60;
        const startTime = `${startHours.toString().padStart(2, "0")}:${startMins
          .toString()
          .padStart(2, "0")}`;
        const endTime = `${endHours.toString().padStart(2, "0")}:${endMins
          .toString()
          .padStart(2, "0")}`;
        res.push(`${startTime} - ${endTime}`);
      }
    }
    setWorkTime(res);
    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentSeconds = now.getSeconds();
    const currentTimeInSeconds =
      currentHours * 3600 + currentMinutes * 60 + currentSeconds;
    const currentCompletedQty = apsData
      .filter((item) => {
        const timeStr = item.end_date.split(" ")[1];
        const [hours, minutes, seconds] = timeStr.split(":").map(Number);
        const endTimeInSeconds = hours * 3600 + minutes * 60 + seconds;
        return endTimeInSeconds < currentTimeInSeconds;
      })
      .map((i) => i.product_qty)
      .reduce((acc, cur) => acc + cur, 0);
    setCurrentCompleteQty(currentCompletedQty);
    const earliestItem = apsData.reduce((earliest, current) => {
      if (
        !earliest ||
        new Date(current.start_date) < new Date(earliest.start_date)
      ) {
        return current;
      }
      return earliest;
    }, null);
    const latestItem = apsData.reduce((latest, current) => {
      if (!latest || new Date(current.end_date) > new Date(latest.end_date)) {
        return current;
      }
      return latest;
    }, null);
    let earliestTimeString = "";
    if (earliestItem) {
      const date = new Date(earliestItem.start_date);
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      earliestTimeString = `${hours}:${minutes}`;
    }
    let latestTimeString = "";
    if (latestItem) {
      const date = new Date(latestItem.end_date);
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      latestTimeString = `${hours}:${minutes}`;
    }
    setWorkTimeString({
      earliest: earliestTimeString,
      latest: latestTimeString,
    });
  }, [apsData]);

  // Refresh Token 갱신
  useEffect(() => {
    let refreshInterval;

    const setupRefreshInterval = () => {
      if (refreshInterval) {
        console.log("Clearing existing interval");
        clearInterval(refreshInterval);
      }

      refreshInterval = setInterval(async () => {
        try {
          console.log("토큰 갱신중");
          await refresh(); // Refresh Token 갱신
          console.log("토큰 갱신 완료");
        } catch (error) {
          console.error("Failed to refresh tokens:", error);
          await unload();
          await auth.logout();
        }
      }, 12 * 60 * 60 * 1000);
    };

    setupRefreshInterval();

    return () => {
      console.log("Clearing interval on cleanup");
      clearInterval(refreshInterval); // 컴포넌트 언마운트 시 정리
    };
  }, [refresh, auth, unload]);

  // disasterScenario 상태가 변경될 때마다 Redux 상태 업데이트
  useEffect(() => {
    if (disasterScenario) {
      dispatch(
        setDisasterStatus({
          isActive: true,
          // 모든 항목이 is_checked === 2 (조치완료) 상태인지 확인
          isAllChecked: disasterScenario.checklist.every(
            (item) => item.is_checked === 2
          ),
        })
      );
    } else {
      dispatch(
        setDisasterStatus({
          isActive: false,
          isAllChecked: false,
        })
      );
    }
  }, [disasterScenario, dispatch]);

  // 웹소켓 연결 및 이벤트 핸들러 설정
  useEffect(() => {
    if (!systemStatus.SAFE) return; // SAFE 미사용 시 웹소켓 연결 안 함

    if (!socketRef.current) {
      let socketUrl;
      try {
        const url = new URL(API_URL);
        socketUrl = url.origin;
      } catch (error) {
        socketUrl = window.location.origin;
      }
      const socket = io(socketUrl + "/fire", {
        path: "/socket.io/",
        withCredentials: true,
        transports: ["websocket"],
      });
      socketRef.current = socket;

      socket.on("connect", () => {
        console.log("Fire alarm namespace connected");
        // 1. 구독
        socket.emit("subscribe", { group_code, project_code }, (response) => {
          console.log("Subscribed:", response);
          // 2. 구독 성공 후, 현재 재난 상태 요청
          socket.emit("disaster:getStatus", { group_code, project_code });
        });
      });

      socket.on("disaster:started", (data) => {
        console.log("Disaster started:", data);
        setDisasterScenario(data);
      });

      socket.on("disaster:itemUpdated", (update) => {
        console.log(
          "%c[WebSocket] 'disaster:itemUpdated' 이벤트 수신",
          "color: #00ddff; font-weight: bold;",
          update
        );
        setDisasterScenario((prev) => {
          console.log("%c[State Update] 이전 상태:", "color: #ff8c00;", prev);

          if (!prev || prev.log_id !== update.log_id) {
            console.warn(
              "[State Update] 업데이트 무시됨: log_id가 다르거나 이전 상태가 없음."
            );
            return prev;
          }

          const newChecklist = prev.checklist.map((item) => {
            if (item.step_id === update.step_id) {
              // 서버에서 받은 업데이트 내용 전체를 기존 아이템에 덮어쓰기
              return { ...item, ...update };
            }
            return item; // 변경 없는 아이템은 그대로 반환
          });

          // 불변성을 유지하며 새로운 상태 객체 생성
          const newState = { ...prev, checklist: newChecklist };
          console.log(
            "%c[State Update] 설정될 새로운 상태:",
            "color: #00ff00; font-weight: bold;",
            newState
          );
          return newState;
        });
      });

      socket.on("disaster:resolved", (data) => {
        console.log("Disaster resolved:", data);
        toast.success(i18n.t("pages.dt.disasterResolved"));
        setDisasterScenario(null);
      });

      socket.on("disconnect", () => {
        console.log("Fire alarm namespace disconnected");
      });
    }

    return () => {
      if (socketRef.current && socketRef.current.connected) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [group_code, project_code, systemStatus.SAFE]);

  const handleChecklistItem = useCallback((step_id, new_status) => {
    // userInfo가 로드되었는지 먼저 확인
    if (!userInfo) {
      toast.error(
        t("pages.dt.userInfoNotLoaded")
      );
      return;
    }

    if (socketRef.current && disasterScenario) {
      socketRef.current.emit("disaster:checkItem", {
        log_id: disasterScenario.log_id,
        step_id,
        is_checked: new_status, // 새로운 상태 값을 직접 전송
        user_id: userInfo?.user_name || "Unknown",
        group_code,
        project_code,
      });
    }
  }, [userInfo, disasterScenario?.log_id, group_code, project_code, t]);

  // 재난 상황 종료시 전부 체크되었는지 확인 (임시 보류)
  // const handleCloseDisasterDialog = () => {
  //   if (socketRef.current && disasterScenario) {
  //     // 모든 항목이 체크되었는지 확인 (is_checked === 2)
  //     const allChecked = disasterScenario.checklist.every(
  //       (item) => item.is_checked === 2
  //     );
  //     if (allChecked) {
  //       socketRef.current.emit("disaster:resolve", {
  //         log_id: disasterScenario.log_id,
  //         group_code,
  //         project_code,
  //       });
  //     } else {
  //       toast.warn(t("pages.dt.checkAllItems"));
  //     }
  //   }
  // };

  useEffect(() => {
    const unityContainer = unityContainerRef.current;

    const handleDevicePixelRatioChange = () => {
      // console.log("Device Pixel Ratio:", window.devicePixelRatio);
      setDevicePixelRatio(window.devicePixelRatio);
      updateCanvasSize();
    };

    const mediaMatcher = window.matchMedia(
      `screen and (resolution: ${window.devicePixelRatio}dppx)`
    );
    mediaMatcher.addEventListener("change", handleDevicePixelRatioChange);

    updateCanvasSize();

    const observer = new ResizeObserver(() => {
      updateCanvasSize();
    });

    if (unityContainer) {
      observer.observe(unityContainer);
    }

    return () => {
      mediaMatcher.removeEventListener("change", handleDevicePixelRatioChange);
      if (unityContainer) {
        observer.unobserve(unityContainer);
      }
    };
  }, [devicePixelRatio]);

  useEffect(() => {
    window.SFV_UpdateData = SFV_UpdateData;
    window.SFV_UpdateStatus = SFV_UpdateStatus;
    window.SFV_FinishLoading = SFV_FinishLoading;
    return () => {
      delete window.SFV_UpdateData;
      delete window.SFV_UpdateStatus;
      delete window.SFV_FinishLoading;
    };
  }, [SFV_UpdateData, SFV_UpdateStatus, SFV_FinishLoading]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const clickedInsideDrawer = event.target.closest(".MuiDrawer-paper");
      const clickedInsideDialog = event.target.closest(".MuiDialog-paper");
      if (drawerOpen && !clickedInsideDrawer && !clickedInsideDialog) {
        setDrawerOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [drawerOpen]);
  useEffect(() => {
    if (!drawerOpen) {
      sendMessage("Canvas", "ClearMachineData", "Picking");
      setCurrentMchId("");
    }
  }, [drawerOpen, sendMessage]);
  useEffect(() => {
    if (!stockOpen) {
      sendMessage("Canvas", "ClearMachineData", "Picking");
      setCurrentMchId("");
    }
  }, [stockOpen, sendMessage]);
  useEffect(() => {
    const preventDefault = (event) => {
      event.preventDefault();
    };

    const bodyElement = document.body;

    bodyElement.addEventListener("contextmenu", preventDefault);
    bodyElement.addEventListener("dragstart", preventDefault);
    bodyElement.addEventListener("selectstart", preventDefault);

    return () => {
      bodyElement.removeEventListener("contextmenu", preventDefault);
      bodyElement.removeEventListener("dragstart", preventDefault);
      bodyElement.removeEventListener("selectstart", preventDefault);
    };
  }, []);

  const handleBrokenImageClose = () => {
    setBrokenImageShow(false);
  };
  const handleWorkOrderOpen = () => {
    if (!apsData.length) {
      toast.info(t("pages.dt.noDataToShow"));
      return;
    }
    setWorkOrderOpen(true);
  };
  const handleWorkOrderClose = () => {
    setWorkOrderOpen(false);
  };
  const handleRiskListOpen = () => {
    setRiskListOpen(true);
  };
  const handleRiskListClose = () => {
    setRiskListOpen(false);
  };
  const handleCCTVOpen = () => {
    setCCTVShow(true);
  };

  const handleCCTVClose = () => {
    setCCTVShow(false);
  };

  const handleBrokenLogDialogOpen = (mchId) => {
    fetchBrokenLogData(mchId);
    setbrokenLogShow(true);
  };

  const handleBrokenLogDialogClose = () => {
    setbrokenLogShow(false);
  };
  const isMachineBroken = drawerContent?.machine_status === 9;
  return (
    <div id="sfv-page">
      <SideBar
        pageType="LE"
        handleLogout={handleLogout}
        onLanguageChange={(lang) => {
          const lang2 = lang.substring(0, 2);
          const unityLang = lang2 === "jp" ? "JPN" : lang2 === "ko" ? "KOR" : "ENG";
          sendMessage("Canvas", "SetPropertyValue", "Language:" + unityLang);
        }} onDtInfoModeChange={handleDtInfoModeChange} />
      <Box
        sx={{
          position: "absolute",
          top: "20px",
          left: "80px",
          right: 0,
          display: "flex",
          justifyContent: "center",
          zIndex: 10,
        }}
      >
        <KPICards />
      </Box>
      <div
        ref={unityContainerRef}
        style={{
          width: "calc(100vw - 80px)",
          height: "100vh",
          overflow: "hidden",
          marginLeft: "80px",
        }}
      >
        <Unity
          unityProvider={unityProvider}
          style={{ width: "100%", height: "100%" }}
          // 중요한 옵션, 디폴트가 true인데 WebGL 해상도를 캔버스 사이즈에 강제로 일치시킴
          matchWebGLToCanvasSize={false}
        />

        {/* 로딩 화면 */}
        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <img
              src="/images/ese_logo.png"
              alt="ESE Logo"
              style={{
                width: "200px",
                marginBottom: "30px",
              }}
            />
            <div className="loader"></div>
          </div>
        )}

        {/** 위험성 레벨 상세정보 창 */}
        {modeStatus === RenderMode.SAFETY && (
          <>
            <RiskLevelDetails
              isOpen={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              group_code={group_code}
              project_code={project_code}
              currentMchId={currentMchId}
              // currentMchId={67} // TODO: 임시 하드코딩, 추후 currentMchId로 변경
              referenceDate={referenceDate}
            />
            {/* 위험성 평가 지표 창 */}
            <RiskIndicators
              //isAvailable={true}
              // isAvailable={false} 
              isComplexUI={drawerOpen}
              // isComplexUI={false} 
              group_code={group_code}
              project_code={project_code}
              referenceDate={referenceDate}
            />
          </>
        )}

        {/* 장비 상세 정보창 */}
        {modeStatus === RenderMode.DT && (
          <Drawer
            anchor="right"
            open={drawerOpen}
            ModalProps={{
              keepMounted: true,
              hideBackdrop: true,
            }}
            sx={{
              "& .MuiDrawer-paper": {
                backgroundColor: "#121212",
                opacity: 0.85,
                color: "#ffffff",
                width: 350,
              },
            }}
          >
            <Box
              id="drawer-header"
              sx={{
                paddingY: "0.5rem",
                paddingX: "0.75rem",
                backgroundColor: "#000000",
              }}
              role="presentation"
            >
              <DrawerHeader>
                <Box sx={{ margin: 0, fontSize: "1.5em", fontWeight: 500 }}>
                  {drawerContent ? drawerContent.machine_name : t("pages.dt.unlinkedMachine")}
                </Box>
                <Box
                  sx={{
                    margin: 0,
                    fontSize: "1.2em",
                    fontWeight: 400,
                    color: "#878a99",
                  }}
                >{t("pages.dt.linkedId", { id: currentMchId })}</Box>
                <IconButton
                  onClick={() => setDrawerOpen(false)}
                  sx={{ color: "#ced4da" }}
                >
                  <CloseIcon />
                </IconButton>
              </DrawerHeader>
            </Box>
            <Divider />
            <Box
              id="progress-bar"
              sx={{ padding: 3, opacity: 1 }}
              role="presentation"
            >
              <CustomProgressBar
                machineStatus={drawerContent?.machine_status}
                plannedQty={totalQty ?? 1}
                resultQty={currentCompleteQty ?? 0}
              />
              <ProgressInfo
                startTime={workTimeString.earliest || t("pages.dt.noInfo")}
                endTime={workTimeString.latest || t("pages.dt.noInfo")}
              />
            </Box>
            <Divider />
            {isMachineBroken ? (
              <Box
                id="drawer-title"
                sx={{ padding: 3, backgroundColor: "#000000" }}
                role="presentation"
              >
                <DrawerTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ margin: 0, fontSize: "1.2em", fontWeight: 500 }}>
                    {t("pages.dt.brokenInfoTitle")}
                  </Box>
                  <Chip
                    label={t("pages.dt.brokenOccurredChip")}
                    size="small"
                    color="error"
                    variant="tonal"
                    icon={
                      <Icon
                        name="warningIcon"
                        style={{
                          width: "12px",
                          height: "12px",
                          color: "#FF0000",
                        }}
                      />
                    }
                  />
                </DrawerTitle>
              </Box>
            ) : (
              <Box
                id="drawer-title"
                sx={{ padding: 3, backgroundColor: "#000000" }}
                role="presentation"
              >
                <DrawerTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ margin: 0, fontSize: "1.2em", fontWeight: 500 }}>
                    {t("pages.dt.productionInfoTitle")}
                  </Box>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleWorkOrderOpen}
                  >
                    {t("pages.dt.workOrder")}
                  </Button>
                </DrawerTitle>
              </Box>
            )}
            <Divider />
            <Box
              id="drawer-content"
              sx={{ padding: "0.4rem" }}
              role="presentation"
            >
              <DrawerContent>
                <StyledTable>
                  {isMachineBroken ? (
                    <tbody>
                      <tr>
                        <td>{t("pages.dt.brokenTime")}</td>
                        <td>{drawerContent?.machine_update_date}</td>
                      </tr>
                      <tr>
                        <td>{t("pages.dt.expectedCompletion")}</td>
                        <td>{t("pages.dt.undetermined")}</td>
                      </tr>
                      <tr>
                        <td>{t("pages.dt.worker")}</td>
                        <td>{t("pages.dt.undetermined")}</td>
                      </tr>
                      <tr>
                        <td>{t("pages.dt.brokenPhoto")}</td>
                        <td>
                          <button
                            onClick={() => setBrokenImageShow(true)}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#007bff",
                              textDecoration: "underline",
                              cursor: "pointer",
                              padding: 0,
                            }}
                          >
                            {t("pages.dt.viewPhoto")}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <ApsInformation
                      apsData={apsData}
                      workTime={workTime}
                      totalQty={totalQty}
                    />
                  )}
                </StyledTable>
              </DrawerContent>
            </Box>
            <Divider />
            {/* 위험성 평가 점수 테이블 */}
            <Box
              id="drawer-title"
              sx={{ padding: 3, backgroundColor: "#000000" }}
              role="presentation"
            >
              <DrawerTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ margin: 0, fontSize: "1.2em", fontWeight: 500 }}>
                  {t("pages.dt.riskAssessmentInfoTitle")}
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleRiskListOpen}
                >
                  {t("pages.dt.detailInfo")}
                </Button>
              </DrawerTitle>
            </Box>
            <Divider />
            <Box id="drawer-content" sx={{ padding: 3 }} role="presentation">
              <DrawerContent>
                <RiskAssessment
                  highCount={riskData?.total_high_risk_count}
                  mediumCount={riskData?.total_medium_risk_count}
                  lowCount={riskData?.total_low_risk_count}
                />
              </DrawerContent>
            </Box>
            <Box
              id="drawer-title"
              sx={{ padding: 3, backgroundColor: "#000000" }}
              role="presentation"
            >
              <DrawerTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ margin: 0, fontSize: "1.2em", fontWeight: 500 }}>
                  {t("pages.dt.equipmentDetailTitle")}
                </Box>
              </DrawerTitle>
            </Box>
            <Divider />
            <Box id="drawer-content" sx={{ padding: 3 }} role="presentation">
              <DrawerContent>
                <StyledTable>
                  <tbody>
                    <tr>
                      <td>{t("pages.dt.manageCode")}</td>
                      <td>{drawerContent?.machine_manage_code}</td>
                    </tr>
                    <tr>
                      <td>{t("pages.dt.machineCategory")}</td>
                      <td>{drawerContent?.machine_category_name}</td>
                    </tr>
                    <tr>
                      <td>{t("pages.dt.machineGroup")}</td>
                      <td>{drawerContent?.machine_group_name}</td>
                    </tr>
                    <tr>
                      <td>{t("pages.dt.manufacturer")}</td>
                      <td>{drawerContent?.machine_manufacturer}</td>
                    </tr>
                    <tr>
                      <td>{t("pages.dt.modelName")}</td>
                      <td>{drawerContent?.machine_model_name}</td>
                    </tr>
                    <tr>
                      <td>{t("pages.dt.purchaseDate")}</td>
                      <td>{drawerContent?.machine_purchase_date}</td>
                    </tr>
                    <tr>
                      <td>{t("pages.dt.voltage")}</td>
                      <td>{drawerContent?.machine_volt}</td>
                    </tr>
                    <tr>
                      <td>{t("pages.dt.size")}</td>
                      <td>{drawerContent?.machine_size}</td>
                    </tr>
                  </tbody>
                </StyledTable>
              </DrawerContent>
            </Box>
          </Drawer>
        )}
        <Divider />
      </div>
      <DateModal
        open={dateSystemStatus}
        // setOpen={dispatch(!dateSystemStatus)}
        onReferenceDateChange={handleSetReferenceDate}
      />
      {/* <MergeSummary />
      <SummaryResult />
      <SummaryLine sendMessage={sendMessage} />
      <PlanWeek />
      <GanttSimulation1 />
      <GanttSimulation2 />
      <WorkerTable /> */}
      <CarouselTotal sendMessage={sendMessage} />
      <BrokenImageDialog
        open={BrokenImageShow}
        onClose={handleBrokenImageClose}
        imageUrl="/images/broken_241014.png"
        assetInfo={drawerContent?.asset_name || t("pages.dt.unlinkedMachine")}
      />
      <CCTVDialog
        open={CCTVShow}
        onClose={handleCCTVClose}
        videoUrl="/CCTV/CCTV_SAMPLE.mp4"
        assetInfo={drawerContent?.asset_name || t("pages.dt.unlinkedMachine")}
      />
      <BrokenLogDialog
        open={brokenLogShow}
        onClose={handleBrokenLogDialogClose}
        data={brokenLogData}
        assetInfo={drawerContent?.asset_name || t("pages.dt.unlinkedMachine")}
      />
      <WorkOrderModal
        open={workOrderOpen}
        onClose={handleWorkOrderClose}
        assetInfo={drawerContent?.machine_name || t("pages.dt.unlinkedMachine")}
        data={apsData}
      />
      <RiskListModal
        open={riskListOpen}
        onClose={handleRiskListClose}
        assetInfo={drawerContent?.machine_name || t("pages.dt.unlinkedMachine")}
        data={riskData.details}
      />
      {/* disasterScenario 상태가 있을 때만 렌더링 */}
      {disasterScenario && (
        <DisasterChecklistDialog
          scenarioData={disasterScenario}
          onCheckItem={handleChecklistItem}
          userId={userInfo?.mem_id}
        />
      )}
      <StockSideBar
        stockOpen={stockOpen}
        setStockOpen={setStockOpen}
        currentMchId={currentMchId}
        setMonthStockGraphOpen={setMonthStockGraphOpen}
        setDayStockGraphOpen={setDayStockGraphOpen}
      />
      <MonthStockGraph
        open={monthStockGraphOpen}
        setMonthStockGraphOpen={setMonthStockGraphOpen}
        currentMchId={currentMchId}
      />
      <DayStockGraph
        open={dayStockGraphOpen}
        setDayStockGraphOpen={setDayStockGraphOpen}
        currentMchId={currentMchId}
      />
      {productivityStatus && <ProductivityChart sendMessage={sendMessage} />}
    </div>
  );
}

export default SfvLePage;